import React from "react";
import styled, { keyframes } from "styled-components";
import company1 from "../../../assets/images/company1.jpeg";
import company2 from "../../../assets/images/contactUs/bulding3.jpg";
import company3 from "../../../assets/images/contactUs/bulding2.jpg";

// Keyframe animation for fa-beat
const faBeat = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
`;

// Styled components
const Section = styled.section`
  padding: 40px 20px;
  background-color: #062c3f;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-family: "Poppins", system-ui;
  font-weight: 700;
  font-style: normal;
  font-size: 2.8em;
  margin-bottom: 40px;
  color: #00cbf1;
  text-align: left;

  @media (min-width: 768px) {
    font-size: 2.8em;
  }

  @media (max-width: 480px) {
    font-size: 1.8em;
  }

  span {
    color: #f0faff;
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -10px;
`;

const Col = styled.div`
  flex: 1 0 100%;
  max-width: 100%;
  padding: 10px;

  @media (min-width: 768px) {
    flex: 1 0 50%;
    max-width: 50%;
  }

  @media (min-width: 992px) {
    flex: 1 0 33.3333%;
    max-width: 33.3333%;
  }
`;

const Card = styled.div`
  border: none;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
`;

const CardImg = styled.img`
  width: 100%;
  height: auto;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const CardBody = styled.div`
  padding: 20px;
`;

const CardTitle = styled.h5`
  font-family: "Poppins", system-ui;
  font-weight: 500;
  font-style: normal;
  font-size: 1.2em;
  margin-bottom: 10px;
  color: #095171;

  @media (min-width: 768px) {
    font-size: 1.1em;
  }
`;

const CardText = styled.p`
  font-family: "Poppins", system-ui;
  font-weight: 400;
  font-style: normal;
  font-size: 1em;
  color: #095171;
  line-height: 1.71;

  @media (min-width: 768px) {
    font-size: 0.8em;
    line-height: 1.71;
  }
`;

const Icon = styled.i`
  animation: ${faBeat} 2s infinite;
  margin-right: 8px;
`;

const OurOffices = () => {
  const locations = [
    {
      image: company1,
      alt: "NexTech PLM Solutions Private Limited",
      title: "NexTech PLM Solutions Pvt Ltd",
      address: "4th Floor, R-5 Heights, 27, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune 411027",
      mapLink: "https://www.google.com/maps?q=4th+Floor,+R-5+Heights,+27,+Vishal+Nagar,+Pimple+Nilakh,+Pimpri-Chinchwad,+Pune+411027",
    },
    {
      image: company2,
      alt: "NexTech PLM Solutions Pvt Ltd",
      title: "NexTech PLM Solutions Pvt Ltd",
      address: "NexTech, 635 W 42nd St Suite 37E, New York, NY 10036, USA",
      mapLink: "https://maps.app.goo.gl/PUe92hPZiiCzz6cM7",
    },
    {
      image: company3,
      alt: "NexTech PLM Solutions Pvt Ltd",
      title: "NexTech PLM Solutions Pvt Ltd",
      address: "11 rue des Draperies, 69450 St-Cyr-au-Mont-d'Or, France",
      mapLink: "https://www.google.com/maps?q=11+rue+des+Draperies,+69450+St-Cyr-au-Mont-d'Or,+France",
    },
  ];

  return (
    <Section className="our-offices">
      <Container>
        <Title>
          Our Global <span>Network</span>
        </Title>
        <Row>
          {locations.map((location, index) => (
            <Col key={index}>
              <a href={location.mapLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                <Card>
                  <CardImg src={location.image} alt={location.alt} />
                  <CardBody>
                    <CardTitle>
                      <Icon className="fa-regular fa-building" /> {location.title}
                    </CardTitle>
                    <CardText>
                      <Icon className="fa-solid fa-location-dot" /> {location.address}
                    </CardText>
                  </CardBody>
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </Section>
  );
};

export default OurOffices;
